<template>
    <div class="surface-section px-6 py-5">
        <div class="flex align-items-start flex-column lg:flex-row lg:justify-content-between">
            <div class="flex align-items-start flex-column md:flex-row">
                <img :alt="newspaper.name" :src="logo" class="mr-5 mb-3 lg:mb-0 newspaper-logo" style="width:90px;height:90px" />
                <div>
                    <span class="text-900 font-medium text-3xl">{{ newspaper.name }}</span>
                    <div class="flex align-items-center flex-wrap text-sm">
                        <div class="mr-5 mt-3">
                            <a :href="url(newspaper.website)" rel="nofollow" target="_blank"><i class="pi pi-globe"></i></a>
                            <span class="visually-hidden">Newspaper Website</span>
                        </div>
                        <div class="mr-5 mt-3" v-if="newspaper.facebook">
                            <a :href="url(newspaper.facebook)" rel="nofollow"><i class="pi pi-facebook"></i></a>
                            <span class="visually-hidden">Newspaper Facebook Page</span>
                        </div>
                        <div class="mr-5 mt-3" v-if="newspaper.instagram">
                            <a :href="url(newspaper.instagram)" rel="nofollow"><i class="pi pi-instagram"></i></a>
                            <span class="visually-hidden">Newspaper Instagram</span>
                        </div>
                        <div class="mt-3" v-if="newspaper.twitter">
                            <a :href="url(newspaper.twitter)" rel="nofollow"><i class="pi pi-twitter"></i></a>
                            <span class="visually-hidden">Newspaper Twitter</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {addUrlPrefix} from "@/Misc/helper.js";
import alphanews from '/resources/images/newspapers/alphanews.jpg'
import sigma from '/resources/images/newspapers/sigmalive.jpg'
import politis from '/resources/images/newspapers/politis.jpg'
import kathimerini from '/resources/images/newspapers/kathimerini.jpg'
import omega from '/resources/images/newspapers/omega.jpg'
import ant1 from '/resources/images/newspapers/ant1.jpg'
import author from '/resources/colorlib/img/author.png'
import rik from '/resources/images/newspapers/rik.png'
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        Link,
    },
    props    : {
        newspaper : Object,
    },
    methods  : {
        url(url) {
            return addUrlPrefix(url);
        },
    },
    computed : {
        logo() {
            switch (this.newspaper.name) {
                case 'Alpha News':
                    return alphanews;
                case 'Sigma Live':
                    return sigma;
                case 'Politis':
                    return politis;
                case 'Kathimerini':
                    return kathimerini;
                case 'Omegalive':
                    return omega;
                case 'Ant1':
                    return ant1;
                case 'RIK':
                    return rik;
                default:
                    return author;
            }
        }
    }
};
</script>

<style scoped>
.newspaper-logo {
    border-radius: 50%;  /* Creates the round shape */
    object-fit: cover;   /* Ensures the image covers the area without stretching */
    width: 90px;         /* Width of the image */
    height: 90px;        /* Height of the image, should be equal to width for a perfect circle */
}
.visually-hidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
}
</style>